export async function fetchContent(query) {
    try {
        const res = await fetch('/api/content', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ query })
        });

        const { data } = await res.json();
        return data;
    } catch (error) {
        console.error(`There was a problem retrieving entries with the query \n ${query}`);
        console.error(error);
    }
}
